(function() {
    'use strict';

    var flightProduct = '5';
    var dpProduct = '2,5';
    var dynamicDpAttrs = {
        min_duration: 0,
        age_children: '',
        hotel_rating: 0,
        guest_rating: 0,
        min_cust_reviews: 0,
        room_type: 0,
        hotel_transfer: '',
        rental_car: '',
        beach: '',
        wellness: '',
        min_price_per_person: '',
        max_price_per_person: '',
        board_basis: 0,
        with_sport: '',
        dist_sea: 0,
        dist_ski: 0,
        aid: '',
        target_group: '',
    };
    var omitEmptyKeys = function(obj) {
        return Odigeo._.omit(obj, Odigeo._.filter(Odigeo._.keys(obj), function(key) {
            var value = obj[key];
            return !value || value === '';
        }));
    };
    var getChildrenAges = function(rooms, childTypeAges) {
        return Odigeo._.map(rooms, function(room) {
            return room[childTypeAges];
        });
    };
    var filterChildrenAges = function(ages) {
        return Odigeo._.filter(Odigeo._.flattenDeep(ages), function(age) {
            return age !== 0;
        });
    };
    const getDPDestination = function(segments) {
        return Odigeo._.head(segments).destination.iata ? Odigeo._.head(segments).destination.iata : Odigeo._.head(segments).destination.city;
    };
    const stringToDate = function(value) {
        return typeof value === 'string' ? new Date(value) : value;
    };
    var getCommonSearchData = function(searchParams, segments) {
        var departureDate = Odigeo._.head(segments).dateStr;
        var arrivalDate = Odigeo._.last(segments).dateStr;
        return {
            one_way: searchParams.type === 'oneWay' ? 1 : 0,
            non_stop: searchParams.directFlightsOnly ? 1 : 0,
            cabin_class: searchParams.cabinClass,
            earliest_departure_date: departureDate,
            latest_return_date: arrivalDate,
            max_duration: Odigeo.Utils.getDifferenceInDays(stringToDate(departureDate), stringToDate(arrivalDate)),
            num_adults: searchParams.numAdults,
            num_children: searchParams.numChildren,
            num_infants: searchParams.numInfants,
        };
    };
    var getFlightSearchData = function() {
        var searchParams = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
        var segments = searchParams.searchSegments;

        return Odigeo._.extend({}, getCommonSearchData(searchParams, segments),
            {
                product: flightProduct,
                departure: Odigeo._.head(segments).departure.iata,
                destination: Odigeo._.head(segments).destination.iata,
            });
    };
    var getDpSearchData = function() {
        var searchParams = Odigeo.Utils.parseJson(Odigeo.Storage.get('lastSearchDynpack'));
        var segments = searchParams.searchSegments;
        var childrenAgesGroupedByRoom = getChildrenAges(searchParams.rooms, 'childrenAges');

        return Odigeo._.extend({}, getCommonSearchData(searchParams, segments),
            {
                product: dpProduct,
                level: 1,
                departure: Odigeo._.head(segments).departure.iata,
                destination: getDPDestination(segments),
                age_children: filterChildrenAges(childrenAgesGroupedByRoom).join(','),
            });
    };
    var buildDpData = function(staticConfig) {
        return Odigeo._.extend({},
            dynamicDpAttrs,
            staticConfig.style,
            Odigeo.Utils.parseJson(Odigeo.Storage.get('lastSearchDynpack')) ? getDpSearchData() : {},
            staticConfig.dp);
    };
    var buildFlightData = function(staticConfig) {
        return Odigeo._.extend({},
            staticConfig.style,
            Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters')) ? getFlightSearchData() : {},
            staticConfig.flights);
    };
    var setAdvertisement = function($advList, staticConfig) {
        var isDp = Odigeo.SessionScope.flowProduct === 'dp';
        var config = omitEmptyKeys(isDp ? buildDpData(staticConfig) : buildFlightData(staticConfig));
        window.travelaudience.requestPlacements($advList, config);
    };
    var setAdsOn = function($advList, staticConfig) {
        Odigeo.require(['travelaudience'], function() {
            setAdvertisement($advList, staticConfig);
        });
    };

    Odigeo.Utils.Advertisement = {
        TravelAudience: {
            setAdsOn: setAdsOn,
        },
    };
})();
